<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between" @click="selectOs(object.protocolo)">
      <div class="d-flex w-100">
        <div class="table table-striped table-sm">
          <div class="d-flex col-12 text-center">
            <b class="col-2 text-center fs-5">Protocolo</b>
            <b class="col-1 text-center fs-5">Serviço</b>
            <b class="col-2 text-center fs-5">Endereço</b>
            <b class="col-1 text-center fs-5">Equipe</b>
            <b class="col-2 text-center fs-5">Vencimento</b>
            <b class="col-1 text-center fs-5">Status</b>
            <b class="col-2 text-center fs-5">Andamento</b>
            <b class="entulho fs-5">Entulho</b>
          </div>
          <hr />
          <div v-if="load" class="text-center">
            <div
              v-for="(object, index) in items"
              :key="object.id"
              :class="
                'd-flex flex-column my-2 justify-content-center' +
                `${index % 2 == 0 ? ' whiteTableLine' : ' darkTableLine'}`
              ">
              <div class="d-flex align-items-center">
                <div
                  @dblclick="
                    this.$router.push({
                      name: 'osDetail',
                      params: { id: object.id },
                    })
                  "
                  class="col-2 flex gap-2">
                  <span :class="'hoverClass p-3' + getProtocolClass(object) + 'badge fs-6 protocol'">
                    {{ object.protocolo }}</span
                  >
                </div>
                <b class="col-1">{{ object.idServiceRequested }}</b>
                <div class="col-2 text-start">{{ object.address }}</div>
                <div class="col-1 fs-6">{{ object.idTeam }}</div>
                <div class="col-2">{{ formatDate(object) }}</div>
                <div class="col-1">
                  <div style="font-size: 14.5px">
                    {{ translateProgressText(object.status) }}
                  </div>
                </div>
                <div class="d-flex flex-column col-2 align-items-center">
                  <b style="font-size: 15px">
                    {{ translateStatusText(object.progress) }}
                  </b>
                  <span :class="getProtocolStatusColor(object) + ' ball-small rounded-pill p-2 '"></span>
                </div>
                <div class="col-1 flex align-items-center mx-4">
                  <i
                    v-if="getEntulhoExistence(object.entulho)"
                    class="bi bi-exclamation-diamond-fill col-10 h4 text-red">
                  </i>
                  <i
                    :class="
                      object.showDropdown
                        ? 'bi bi-chevron-up icon h4 col-2  mx-4'
                        : 'bi bi-chevron-down icon h4 col-2 mx-4'
                    "
                    @click="toggleDropdown(object)"></i>
                </div>
              </div>
              <TheTransition>
                <div v-if="object.showDropdown">
                  <div class="d-flex">
                    <div class="card-body">
                      <div class="d-flex flex-column mx-3 align-items-start">
                        <span style="opacity: 0.5"> Descrição: </span>
                        <p>
                          {{ object.observation }}
                        </p>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </TheTransition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    load: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
    },
    date: {
      type: Object,
    },
    check: false,
  },

  data: () => ({
    filterToggle: false,

    pages: null,
    page: 0,
    actualPage: 1,
    limit: 20,

    selectedTeam: null,
    filterProtocol: false,
    showModal: false,
    selectedCard: null,
    points: null,
    items: [],
    itemsProtocol: [],
  }),

  methods: {
    getProtocolClass(object) {
      if (object.openAtDawn) return ' madrugada '
      if (object.inExecution) {
        return ' em-execucao '
      }

      switch (object.progress) {
        case 'NO PRAZO':
          return ' no-prazo '
        case 'EXPIRA EM 2H':
          return ' vence-2h textGray '
        case 'EXPIRA EM 1H':
          return ' vence-1h textGray '
        case 'EM ATRASO':
          return ' vencidos '
        case 'EM EXECUÇÃO':
          return ' em-execucao '
      }
    },
    getProtocolStatusColor(item) {
      switch (item.progress) {
        case 'NO PRAZO':
        case 'EXECUTADO NO PRAZO':
          return 'no-prazo '
        case 'EXPIRA EM 2H':
          return 'vence-2h '
        case 'EXPIRA EM 1H':
          return 'vence-1h '
        case 'EXECUTADO EM ATRASO':
        case 'EM ATRASO':
          return 'bg-red '
        case 'EM EXECUÇÃO':
          return 'em-execucao '
      }
    },

    formatDate(item) {
      return moment(item.vencimento).format('DD/MM/YYYY HH:mm')
    },
    toggleDropdown(object) {
      object.showDropdown = !object.showDropdown
    },
    translateProgressText(status) {
      let text = status
      switch (status) {
        case 'PENDENTE DE CARGA NO EQUIPAMENTO':
          text = 'PENDENTE DE CARGA'
          break
        case 'AGUARDANDO EQUIPE CONFIRMAR RECEBIMENTO':
          text = 'AGUARDAR RECEBIMENTO'
          break
      }
      return text
    },
    getEntulhoColor(entulho) {
      switch (entulho) {
        case 1:
          return ' bg-red'
        case 0:
          return ' bg-success'
        default:
          return ' bg-success'
      }
    },
    translateStatusText(text) {
      switch (text) {
        case 'EXPIRA EM 2 HORAS':
          return 'EXPIRA 2H'
        case 'EXPIRA EM 1 HORA':
          return 'EXPIRA 1H'
        default:
          return text
      }
    },
    getEntulhoExistence(entulho) {
      return entulho === 1
    },
  },
  mounted() {
    for (let index = 0; index < this.items.length; index++) {
      items[index].showDropdown = false
    }
  },
}
</script>

<style>
.whiteTableLine {
  background-color: #f7f7f7;
}
.darkTableLine {
  background-color: #eaeaea;
}
.entulho {
  margin-left: 2%;
}
.textGray {
  color: #1f1f1f;
}
.protocol {
  font-weight: 400;
}
.no-prazo {
  border: none;
  border-radius: 5px;
  background: linear-gradient(-115deg, rgba(0, 128, 0, 1) 0%, rgba(34, 139, 34, 1) 100%); /* Green */
}
.madrugada {
  border: none;
  border-radius: 5px;
  background: linear-gradient(
    -115deg,
    rgba(147, 112, 219, 1) 0%,
    /* Lighter Purple (Plum) */ rgba(75, 0, 130, 1) 100% /* Darker Purple (Indigo) */
  );
}
.em-execucao {
  border: none;
  border-radius: 5px;
  background: linear-gradient(-115deg, rgba(63, 187, 254, 1) 0%, rgba(165, 65, 255, 1) 100%);
}
.vence-1h {
  border: none;
  border-radius: 5px;
  background: linear-gradient(-115deg, rgba(255, 165, 0, 1) 0%, rgba(255, 140, 0, 1) 100%); /* Orange */
}
.vence-2h {
  border: none;
  border-radius: 5px;
  background: linear-gradient(-115deg, rgba(255, 215, 0, 1) 0%, /* Gold */ rgba(255, 165, 0, 1) 100% /* Orange */);
}
</style>
